import T from 'prop-types';

const AuthenticationGate = ({ isAuthenticated, children, fallbackComponent }) => {
  if (isAuthenticated) {
    return children;
  }

  return fallbackComponent;
};

AuthenticationGate.propTypes = {
  isAuthenticated: T.bool.isRequired,
  children: T.node.isRequired,
  fallbackComponent: T.node,
};

AuthenticationGate.defaultProps = {
  fallbackComponent: null,
};

export default AuthenticationGate;
